import { actions } from '@app/action/user';
import Transform from '@app/transformers';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.GET_USER: {
      const transformedDetails = Transform.user(action.details);
      const {
        id,
        full_name,
        email,
        profile_picture,
        language,
        memberships,
        storageFull,
        planTier,
        otpEnabled,
        otpEnabledAt,
      } = transformedDetails;

      return {
        ...state,
        loggedIn: id || false,
        storageFull,
        full_name,
        email,
        profile_picture,
        language,
        memberships,
        planTier,
        otpEnabled,
        otpEnabledAt,
      };
    }

    case actions.CHANGE_USER_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };

    // PASSWORD (Request/Reset)
    case actions.REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
      };

    case actions.CHANGE_USER_IS_VERIFIED:
      return {
        ...state,
        isVerified: action.isVerified,
      };

    case actions.CHANGE_HAS_SKIPPED_VERIFICATION:
      return {
        ...state,
        hasSkippedVerification: action.hasSkippedVerification,
      };

    case actions.UPDATE_USER_EMAIL:
      return {
        ...state,
        email: action.email,
      };

    case actions.UPDATE_ONBOARDED_PREFERENCE:
      return {
        ...state,
        preferences: {
          ...state.preferences,
          onboarded: action.value,
        },
      };

    case actions.DISABLE_OTP:
      return {
        ...state,
        otpEnabled: false,
        otpEnabledAt: null,
      };
  }

  return state;
}
